import gql from 'graphql-tag';

export const checkUserExistV2 = gql`
  mutation checkUserExistV2($username: String!) {
    checkUserExistV2(username: $username) {
      exists
      workstationAuthorizationRequired
    }
  }
`;

export const confirm = gql`
  mutation confirmAccount(
    $confirmationCode: String!
    $email: String!
    $password: String!
  ) {
    confirm(
      confirmationCode: $confirmationCode
      email: $email
      password: $password
    )
  }
`;
